import styled from 'styled-components';

export const DDJRouteContainer = styled.div`
    max-width: 1456px;
    margin: 0 auto;
    padding: 0 16px;
`;

export const DDJWrapper = styled.div`
    width: 100%;
    padding: 0px;
    padding-top: 40px;
    padding-bottom: 10px;
`;

/**
 * Preloader wrapper that keeps the DDJ PBC hidden but rendered.
 * This allows the PBC to initialize in the background before the user navigates to the DDJ page.
 * Using opacity: 0 instead of visibility: hidden to allow the PBC to fully initialize
 * while remaining invisible to the user.
 */
export const DDJPreloaderWrapper = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    pointer-events: none;
    z-index: -1;
`;
